export { DeceasedListPageHeader } from "./DeceasedListPageHeader";
export { DeceasedListTable } from "./DeceasedListTable";
